import { makeVar } from '@apollo/client';

// This is the note string in the note floating box.
const noteVar = makeVar('');

export { noteVar };
